import { createFileRoute } from '@tanstack/react-router'
import { ScorecardTrash } from './ScorecardTrash'

export const Route = createFileRoute('/settings/scorecard_/trash/')({
  component: () => <ScorecardTrash />,
})
